import { PureComponent } from "react";
import ProtoTypes from 'prop-types';
import { Menu } from "semantic-ui-react";

class BlogItem extends PureComponent {
    handleItemClick = (e, { name }) => this.props.onClick(e, { name })

    render() {
        const { name, activeItem } = this.props;
        return <Menu.Item
            name={name}
            active={activeItem === name}
            onClick={this.handleItemClick}
        />
    }
}

BlogItem.protoTypes = {
    author: ProtoTypes.string,
    name: ProtoTypes.string,
    onClick: ProtoTypes.func
}

BlogItem.defaultProps = {
    author: "yungkei",
    name: "",
    onClick: (e, { name }) => { }
}

export default BlogItem;